import { css, cx } from "@emotion/css"
import { isAfter } from "date-fns"
import { useMemo } from "react"

import CloseButton from "@p-ban/common/src/components/button/CloseButton/CloseButton"
import Image from "@p-ban/common/src/components/html/Image"
import useBool from "@p-ban/common/src/hooks/useBool"
import { getDayOfWeek, formatMonthDay } from "@p-ban/common/src/utils/DateUtils"

import useChineseNewYearQuery from "../../../api/schedule/useChineseNewYearQuery"
import COLOR_CODE from "../../../features/oneClickEstimate/pcb/constant/color"
import LAYOUT from "../../../features/oneClickEstimate/pcb/constant/layout"
import LINKS from "../../../features/oneClickEstimate/pcb/constant/links"
import Link from "../../ui/Link/Link"

import warning from "./warning.svg"

const useChineseNewYear = () => {
  const [start, end] = useChineseNewYearQuery()
  const today = useMemo(() => new Date(), [])
  const [isOpen, , close] = useBool(true)

  return {
    isOpen: isOpen && !!start && !!end && isAfter(end, today),
    close,
    start: start ? `${formatMonthDay(start)}（${getDayOfWeek(start)}）` : "",
    end: end ? `${formatMonthDay(end)}（${getDayOfWeek(end)}）` : "",
  }
}

const CalenderInfo = ({ sticky }: { sticky: boolean }) => {
  const { isOpen, close, start, end } = useChineseNewYear()

  if (!isOpen) {
    return null
  }

  return (
    <div className={cx(styles.container, sticky && styles.sticky)}>
      <Image src={warning} alt="" width={35} height={35} />
      <p>
        {start}～{end}:海外工場休業の為、受付制限がございます。
        <br />
        詳しくは{" "}
        <Link href={LINKS.CALENDER} target="_blank">
          営業カレンダー
        </Link>{" "}
        をご確認ください。
      </p>
      <CloseButton onClick={close} className={styles.closeButton} />
    </div>
  )
}

export default CalenderInfo

const styles = {
  container: css`
    display: flex;
    column-gap: 10px;
    padding: 15px;
    margin-bottom: 20px;
    background-color: ${COLOR_CODE.WHITE};
    border: 2px solid ${COLOR_CODE.GREEN};
  `,
  sticky: css`
    position: sticky;
    top: ${LAYOUT.HEADER_HEIGHT}px;
    z-index: 3;
  `,
  closeButton: css`
    margin-left: auto;
  `,
}
